import React from "react";

import { css } from "@emotion/css";
import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";

import { useInitPostHog } from "@/hooks/useInitPostHog.ts";
import { useStyles } from "@/hooks/useStyles";
import { AuthenticatedPageHeader } from "@/uiKit/organisms/AuthenticatedPageHeader";
import { PageFooter } from "@/uiKit/organisms/PageFooter";
import { CriticalErrorPage } from "@/uiKit/pages/CriticalErrorPage.tsx";
import { LoadingPage } from "@/uiKit/pages/LoadingPage.tsx";

const RootLayout: React.FC = () => {
  const styles = useStyles(makeStyles);
  useInitPostHog();
  return (
    <div className={styles.container}>
      <AuthenticatedPageHeader />
      <div className={styles.content}>
        <Outlet />
      </div>
      <PageFooter />
    </div>
  );
};

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/unsupported-browser") return;
    if (!navigator || !navigator.usb || !navigator.serial) {
      throw redirect({ to: "/unsupported-browser" });
    }
  },
  component: RootLayout,
  pendingComponent: LoadingPage,
  wrapInSuspense: true,
  errorComponent: CriticalErrorPage,
  notFoundComponent: () => <CriticalErrorPage reset={() => {}} error={null} />,
});

const makeStyles = () => ({
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
  `,
  content: css`
    flex: 1 1;
    width: 100%;
  `,
});
